// extracted by mini-css-extract-plugin
export default {"Box":"VerifyAttestation-module__Box__g8LgCXI","CopyToClipboardButton":"VerifyAttestation-module__CopyToClipboardButton__RXSAlet"};